import {documentFeatureKey, documentsReducers, DocumentsState} from '@documents/documents.state';
import {combineReducers, createFeatureSelector} from '@ngrx/store';
import {applicationsFeatureKey, applicationsReducer, ApplicationsState} from '@applications/_store/applications.reducer';
import {communicationFeatureKey, communicationReducers, CommunicationState} from '@communication/communication.state';
import {associationFeatureKey, associationReducers, AssociationState} from '@association/association.state';
import {accountingFeatureKey, accountingReducers, AccountingState} from '@accounting/accounting.state';

export const organizationFeatureKey = 'organizationCabinet';

export interface OrganizationCabinetState {
    [communicationFeatureKey]: CommunicationState,
    [applicationsFeatureKey]: ApplicationsState,
    [documentFeatureKey]: DocumentsState,
    [accountingFeatureKey]: AccountingState,
    [associationFeatureKey]: AssociationState,
}

export const organizationCabinetReducers = combineReducers({
    [communicationFeatureKey]: communicationReducers,
    [applicationsFeatureKey]: applicationsReducer,
    [documentFeatureKey]: documentsReducers,
    [accountingFeatureKey]: accountingReducers,
    [associationFeatureKey]: associationReducers
});

export const getOrganizationCabinetState = createFeatureSelector<OrganizationCabinetState>(organizationFeatureKey);
